<template>
 <v-card class="justify-center text-center mx-auto" max-width="600px">
  <v-card-text class="justify-center text-center">
   <div class="d-flex flex-column">

    <v-alert type="info" outlined text v-if="datas.length === 0 && !loading">
     Não possuimos nenhum dia disponivel para este tipo de atendimento
    </v-alert>
    <template v-else>
     <b class="mb-4">Escolha o dia que melhor te atender</b>
     <v-date-picker full-width v-model="selectedDate" @input="filterDates(selectedDate)"
      :allowed-dates="disabledDates"></v-date-picker>
    </template>
   </div>
  </v-card-text>
  <v-card-actions class="justify-end">
   <v-btn text @click="$emit('update-step', 1)">
    Voltar
   </v-btn>
   <v-btn color="primary" @click="$emit('update-step', 3)" :disabled="!selectedDate">
    Continuar
   </v-btn>
  </v-card-actions>
 </v-card>
</template>
<script>
import fichaClinicaService from '@/services/fichaClinica'
import { format } from 'date-fns'

export default {
 props: {
  tipoAtendimento: {
   required: true,
   type: String
  }
 },
 data() {
  return {
   stepper: 1,
   user: null,
   loading: false,
   loadingUpdate: false,
   datas: [],
   medicoHorarios: [],
   selectedDate: null
  }
 },
 methods: {
  disabledDates(val) {
   return this.datas.includes(val)
  },
  async buscaHorariosAmbulatoriais() {
   this.$showLoading()
   try {
    const { data } = await fichaClinicaService.buscaHorariosAmbulatoriais(this.tipoAtendimento)
    this.datas = data.datas
    this.medicoHorarios = data.medicos
   } catch (error) {
    console.error(error)
    this.$showErrorMessage(error.response.data.message)
   } finally {
    this.$hideLoading()
   }
  },
  filterDates(date) {
   const medicosHorariosFiltered = this.medicoHorarios.map(medicoHorarios => {
    const horarios = medicoHorarios.horarios.filter(item => format(new Date(item.horario), 'yyyy-MM-dd') === date)
    return { nome: medicoHorarios.nome, id: medicoHorarios.id, horarios }
   })
   this.$emit('on-change-date', { data: this.selectedDate, medicoHorarios: medicosHorariosFiltered })
  }
 },
 mounted() {
  this.buscaHorariosAmbulatoriais()
 },
}
</script>